import { HttpClient } from '@angular/common/http';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Facility } from '../models/facility.model';
import { FacilityContractStatus } from '../models/facility-contract-status.model';
import { interpolateParams } from 'src/app/shared/utilities/interpolate-params';
import { combine } from 'src/app/shared/utilities/route';

@Injectable({
    providedIn: 'root'
})
export class MarginCalculatorFacilityService extends MarginCalculatorBaseService {
    hospitalState = '';
    hospitalCity = '';

    constructor(private readonly _http: HttpClient) {
        super();
    }

    get isCA(): boolean {
        return this.hospitalState === 'CA';
    }

    get isAK(): boolean {
        return this.hospitalState === 'AK';
    }

    get isVI(): boolean {
        return this.hospitalState === 'VI';
    }

    getFacilityInfo(facilityId: number): Observable<Facility> {
        const url = combine(this.coreApiPath, 'margin-calculator/facility-info');
        const params = interpolateParams({ facilityId });
        return this._http.get<Facility>(url, { params }).pipe(
            tap((response) => {
                response.discountPercent = response.discountPercent / 100;
                response.extDiscount = response.extDiscount / 100;
                this.hospitalState = response.hospitalState?.substring(0, 2);
                this.hospitalCity = response.hospitalCity?.trim();
            })
        );
    }

    getFacilities(name: string, count: number, exactSearch: boolean = false): Observable<Facility[]> {
        const url = combine(this.coreApiPath, 'margin-calculator/facility-names');
        const params = interpolateParams({ name, count , exactSearch });
        return this._http.get<Facility[]>(url, { params });
    }

    getContractStatusForFacility(facilityId: number): Observable<FacilityContractStatus> {
        const url = combine(this.coreApiPath, `margin-calculator/facilities/${facilityId}/contract-status`);
        return this._http.get<FacilityContractStatus>(url);
    }
}
